import {
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  numberedEnv,
  isNumberedEnv,
  sentryDsn,
  amplitudeAPIKey,
  muiProKey,
} from "@src/runtime-config-base";
import { RuntimeConfig } from "@src/runtime-config-types";

export const runtimeConfig: RuntimeConfig = {
  environment: "staging",
  appRegion: "com",
  appEnv: "com-staging",
  displayAppEnv: "Staging INTL",
  urls: {
    apiUrl: "https://core.api.staging.holobuilder.com",
    baseUrl: "https://admin.staging.holobuilder.com",
    dashboardUrl: "https://sphere.staging.holobuilder.com",
    webEditorUrl: "https://app.staging.holobuilder.com/app",
    entryPageUrl: "https://entry.staging.holobuilder.com",
    adminPanelApi: "https://admin.staging.holobuilder.com/api",
    cookieManagerUrl:
      "https://cookies.staging.holobuilder.com/cookie-manager/manager/latest",
  },
  features: {
    muiProKey,
    amplitudeAPIKey,
  },
  keys: {
    sentryDsn,
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support+staging@holobuilder.com",
  isNumberedEnv,
  numberedEnv,
};
